<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="color-guide">
          <div
            class="color-item"
            v-for="(item, index) in ColorAndDescription"
            :key="index"
          >
            <div
              class="color-swatch"
              :style="{ backgroundColor: item.Color }"
            ></div>
            <div class="color-description">{{ item.Description }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "ColorInfot",
  props: {
    ColorAndDescription: {
      type: Array,
      default: () => []
    }
  },

  data() {}
};
</script>

<style scoped>
.color-guide {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  float: right;
  /* justify-content: space-between; */
}

.color-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.color-swatch {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
}

.color-description {
  margin-left: 10px;
}
</style>
